import React from 'react';
import { shape } from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { FREE_SHIPPING_THRESHOLD, GREEN_DELIVERY_TRUCK_ICON } from './constants';
import './DeliveryMessage.style.scss';

export const DeliveryMessage = ({ totalPrice }) => {

  return (
    <>
      <Col className="fbt-appliance-delivery-message">
        {totalPrice && totalPrice?.pricing?.value >= FREE_SHIPPING_THRESHOLD
          ? (
            <>
              <span>
                <img src={GREEN_DELIVERY_TRUCK_ICON} alt="Green Delivery Truck Icon" loading="lazy" />
                <span className="u__text--success"> FREE Home Delivery</span>
              </span>
            </>
          )
          : (
            <span className="fbt-appliance-delivery-message__title--below-threshold u__text--success">
              Free delivery on appliance purchases of $396 and up
            </span>
          )}
      </Col>
    </>
  );
};

DeliveryMessage.propTypes = {
  totalPrice: shape({}).isRequired
};
